export default __webpack_public_path__ + "static/splatter-background-f3f51596d0ceb78b503dbc91bbc7f0db.png";